import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ShopViewModel } from 'stageclip-common';

import { createRequestAllShopsAction } from '../../actions/shopActions';
import { ApiDataTypes } from '../../api/apiDataTypes';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import { getAll } from '../../store/selectors';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../componentBase';
import { AppTable, AppTableColumn } from '../table/appTable';

interface ShopsTableStateProps extends BaseStateProps {
  shops: ShopViewModel[];
  allShopsLoaded: boolean;
}

interface ClientsTableDispatchProps extends BaseDispatchProps {
  loadAllShops: (c: ShopsTable) => void;
}

class ShopsTable extends ComponentBase<{}, ShopsTableStateProps, ClientsTableDispatchProps> {
  private columns: AppTableColumn[] = [
    {
      Header: 'Name',
      accessor: (shop: ShopViewModel) => shop.name,
      id: 'name',
    },
    {
      Header: 'URL',
      accessor: (shop: ShopViewModel) => shop,
      id: 'url',
      Cell: (row: any) => {
        return (
          <a href={row.original.url} target="_blank" rel="noopener noreferrer">
            {row.original.url}
          </a>
        );
      },
    },
    {
      Header: 'Consumer Key',
      accessor: (shop: ShopViewModel) => shop.consumerKey,
      id: 'consumerKey',
    },
    {
      Header: 'Consumer Secret',
      accessor: (shop: ShopViewModel) => shop.consumerSecret,
      id: 'consumerSecret',
    },
  ];

  protected dataLoaded(props: any) {
    return props.allShopsLoaded;
  }

  protected async loadData(props: any) {
    if (!props.allShopsLoaded) {
      await props.loadAllShops(this);
    }
  }

  protected loggedInRender() {
    return (
      <AppTable
        columns={this.columns}
        tableName="shops"
        data={this.props.shops}
        defaultSorted={[{ id: 'name', desc: false }]}
      />
    );
  }
}

function mapStateToProps(state: ClippingPlatformState): ShopsTableStateProps {
  return {
    ...baseMapStateToProps(state),
    allShopsLoaded: state.appStatus.allLoaded[ApiDataTypes.Shops],
    shops: getAll(state.entities.shops),
  };
}

function mapDispatchToProps(dispatch: Dispatch): ClientsTableDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadAllShops: (c: ShopsTable) => dispatch(createRequestAllShopsAction(c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopsTable);
